import * as z from "zod/v4";

export enum BundleReturnMode {
  ALWAYS_TOGETHER = "always_together",
  ALWAYS_SEPARATE = "always_separate",
  CUSTOMER_CHOICE = "customer_choice",
}

// Two distinct Shopify line items can share a variant id (e.g. an upsell adds a
// second line item of the same variant). Keying saved bundle parents only by
// variant id collapses both onto one entry, causing the second parent to
// overwrite the first. Use the line-item-scoped key everywhere.
export function bundleParentKey(
  lineItemId: string,
  parentVariantId: string,
): string {
  return `${lineItemId}::${parentVariantId}`;
}

const ChildDataSchema_ = z.object({ price: z.string(), variantId: z.string() });

export const ChildDataSchema: z.ZodType<ChildData> = ChildDataSchema_;
export interface ChildData extends z.infer<typeof ChildDataSchema_> {}

const BundleDataSchema_ = z.object({ childData: z.array(ChildDataSchema_) });

export const BundleDataSchema: z.ZodType<BundleData> = BundleDataSchema_;
export interface BundleData extends z.infer<typeof BundleDataSchema_> {}
